
export default function Features() {
  const features = [
    {
      icon: 'ri-instagram-line',
      title: 'Campaign Creation',
      description: 'Professional Instagram ad campaigns designed specifically for landscaping businesses to attract quality leads.',
      metric: '50% Cost Cut',
      gradient: 'from-emerald-500 to-blue-500'
    },
    {
      icon: 'ri-calendar-schedule-line',
      title: 'Content Posting',
      description: 'Consistent, engaging content posted regularly to keep your audience engaged and attract new customers.',
      metric: '10x More Leads',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance Tracking',
      description: 'Real-time analytics and reporting to monitor campaign performance and optimize for better results.',
      metric: '99% Satisfaction',
      gradient: 'from-cyan-500 to-emerald-500'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Full Management',
      description: 'Complete campaign management service so you can focus on your landscaping business while we handle the marketing.',
      metric: '24/7 Support',
      gradient: 'from-emerald-600 to-blue-600'
    }
  ];

  return (
    <section id="features" className="py-16 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-5xl font-bold text-gray-900 mb-2 sm:mb-3">
            Everything You Need
          </h2>
          <p className="text-xl sm:text-3xl font-light text-emerald-700">
            for Landscaping Companies
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-white to-blue-50/30 rounded-2xl sm:rounded-3xl p-6 sm:p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-100"
            >
              <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center">
                  <i className={`${feature.icon} text-3xl sm:text-4xl text-white`}></i>
                </div>
              </div>
              
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {feature.title}
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-6">
                {feature.description}
              </p>
              
              <div className="inline-block bg-emerald-100 text-emerald-700 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap">
                {feature.metric}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
